export default __webpack_public_path__ + "static/media/network-error.741e69f1.png";